export default __webpack_public_path__ + "static/media/advantages-ipad-img.d02ec3bc.PNG";